//CREATE_EMAIL_SIGNATURE
export const CREATE_EMAIL_SIGNATURE_REQUEST = "CREATE_EMAIL_SIGNATURE_REQUEST";
export const CREATE_EMAIL_SIGNATURE_SUCCESS = "CREATE_EMAIL_SIGNATURE_SUCCESS";
export const CREATE_EMAIL_SIGNATURE_FAIL = "CREATE_EMAIL_SIGNATURE_FAIL";

//UPDATE_EMAIL_SIGNATURE
export const UPDATE_EMAIL_SIGNATURE_REQUEST = "UPDATE_EMAIL_SIGNATURE_REQUEST";
export const UPDATE_EMAIL_SIGNATURE_SUCCESS = "UPDATE_EMAIL_SIGNATURE_SUCCESS";
export const UPDATE_EMAIL_SIGNATURE_FAIL = "UPDATE_EMAIL_SIGNATURE_FAIL";

//GET_ALL_EMAIL_SIGNATURE
export const GET_ALL_EMAIL_SIGNATURE_REQUEST =
  "GET_ALL_EMAIL_SIGNATURE_REQUEST";
export const GET_ALL_EMAIL_SIGNATURE_SUCCESS =
  "GET_ALL_EMAIL_SIGNATURE_SUCCESS";
export const GET_ALL_EMAIL_SIGNATURE_FAIL = "GET_ALL_EMAIL_SIGNATURE_FAIL";

//DELETE_EMAIL_SIGNATURE
export const DELETE_EMAIL_SIGNATURE_REQUEST = "DELETE_EMAIL_SIGNATURE_REQUEST";
export const DELETE_EMAIL_SIGNATURE_SUCCESS = "DELETE_EMAIL_SIGNATURE_SUCCESS";
export const DELETE_EMAIL_SIGNATURE_FAIL = "DELETE_EMAIL_SIGNATURE_FAIL";
